import React, { useState } from "react";
import { Tooltip, Modal } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

interface InfoIconProps {
    message: string;
    detailedInfo?: string[];
}

const InfoIcon: React.FC<InfoIconProps> = ({ message, detailedInfo }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Tooltip title={message}>
                <InfoCircleOutlined
                    style={{ fontSize: "16px", color: "#1890ff", marginLeft: "8px", cursor: "pointer" }}
                    onClick={showModal}
                />
            </Tooltip>
            <Modal
                title="Details"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
            >
                <ul className="list-disc pl-5">
                    {detailedInfo?.map((info, index) => (
                        <li key={index}>{info}</li>
                    ))}
                </ul>
            </Modal>
        </>
    );
};

export default InfoIcon;